/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    UploadedFileProperty,
    UploadedFilePropertyFromJSON,
    UploadedFilePropertyFromJSONTyped,
    UploadedFilePropertyToJSON,
    UploadedFilePropertyListChunkAllOf,
    UploadedFilePropertyListChunkAllOfFromJSON,
    UploadedFilePropertyListChunkAllOfFromJSONTyped,
    UploadedFilePropertyListChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UploadedFilePropertyListChunk
 */
export interface UploadedFilePropertyListChunk {
    /**
     * 
     * @type {number}
     * @memberof UploadedFilePropertyListChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedFilePropertyListChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedFilePropertyListChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedFilePropertyListChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<UploadedFileProperty>}
     * @memberof UploadedFilePropertyListChunk
     */
    chunk: Array<UploadedFileProperty>;
}

export function UploadedFilePropertyListChunkFromJSON(json: any): UploadedFilePropertyListChunk {
    return UploadedFilePropertyListChunkFromJSONTyped(json, false);
}

export function UploadedFilePropertyListChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadedFilePropertyListChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(UploadedFilePropertyFromJSON)),
    };
}

export function UploadedFilePropertyListChunkToJSON(value?: UploadedFilePropertyListChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(UploadedFilePropertyToJSON)),
    };
}


